module.exports = __webpack_public_path__ + "static/assets/d1b34b404dfaf230517849bd899aa4e7.png";